/**
 * Hub card definitions for ReportsHub.
 * Values remain derived at render time via getValue; structure is static.
 */

export const REPORT_CARDS = [
	{
		id: 'government',
		icon: 'account_balance',
		title: 'Government reporting',
		question: 'Is our evidence ready?',
		metric: 'evidence areas ready',
		pathSuffix: profile => `/compliance/${profile.id}`,
		tone: 'purple',
		getValue: summary => `${summary.ready}/${summary.evidence}`,
	},
	{
		id: 'students',
		icon: 'school',
		title: 'Student insights',
		question: 'What are students discovering and choosing?',
		metric: 'career discovery coverage',
		pathSuffix: () => '/students',
		tone: 'blue',
		getValue: summary => `${summary.assessedPct}%`,
	},
	{
		id: 'workload',
		icon: 'groups',
		title: 'Counsellor report',
		question: 'Where is support happening?',
		metric: 'completed sessions recorded',
		pathSuffix: () => '/workload',
		tone: 'green',
		getValue: summary => summary.sessions,
	},
]
